import React from "react";
import { Link, Typography } from "@mui/material";

const valuesToMatch = [
  `Clinical Benefit: "(.*?)"`,
  `Performance: "(.*?)"`,
  `Adverse Event: "(.*?)"`,
  `(?<=Patient marked as )"(.*?)"`,
  `Target Location: "(.*?)"`,
  `Device Deficient: "(.*?)"`,
  `Indication for Use: "(.*?)"`,
  `(Visit (ID: )?\\d+)`, // PMI-3525: Older DICOM logs included 'ID: ' which product didn't want.
  `"([^"]*)"`,
];
const expression = valuesToMatch.join("|");
const regex = new RegExp(`(${expression})`, "g");

export default function PatientText({
  log,
  hyperlink,
}: {
  log: ActivityLogWithDate;
  hyperlink?: { action: (id: string) => void };
}) {
  let text = log.sentence || "";
  const reasonIndex = text.indexOf("Note/Reason:");
  if (reasonIndex !== -1) {
    text = text.substring(0, reasonIndex + 13);
  }

  const boldText = text.match(regex);
  const separatedText = text.replaceAll(regex, "~");

  function regularText(text: string) {
    const sections: (string | string[])[] = [];
    let sectionsCounter = 0;
    let boldTextIndex = 0;
    for (let i = 0; i < text.length - 1; i++) {
      if (text[i] === "~") {
        if (sections.length >= 1) {
          sectionsCounter++;
        }
        sections[sectionsCounter] = [boldText![boldTextIndex]];
        boldTextIndex++;
        sectionsCounter++;
        continue;
      }
      sections[sectionsCounter] = (sections[sectionsCounter] || "") + text[i];
    }
    return sections;
  }
  const editedText = regularText(separatedText);
  return (
    <Typography variant="body1">
      {editedText.map((item, index) => {
        if (
          hyperlink &&
          String(item).startsWith("Visit") &&
          ((log.type.category === "Visit Related/Not Related" && index === 0) ||
            (log.type.category === "Dicom Annotation" && index === 1))
        ) {
          return (
            <Link
              key={index}
              onClick={() => hyperlink.action(log.encounterId!)}
              sx={{ cursor: "pointer" }}
            >
              <b>{String(item)}</b>
            </Link>
          );
        }
        if (typeof item === "object") {
          return <b key={index}>{String(item)}</b>;
        }
        return <span key={index}>{item}</span>;
      })}
    </Typography>
  );
}
